module.exports = __webpack_public_path__ + "img/mgcenter.b44e853d.svg";